import Api from '@/services/Api';

export default {
  getLastCanbusValues(idCounter) {
    return Api().get(`lastCanbusValues/${idCounter}`);
  },
};
